
import React from 'react';

const directors = [
  {
    name: 'John Doe',
    role: 'Chief Executive Officer',
    bio: 'John has over 20+ years of experience in the tech industry.',
    imageUrl:require ('../assets/emma2-removebg.png')
  },
  {
    name: 'Jane Smith',
    role: 'Service Delivery Manager',
    bio: 'Jane specializes in financial management and strategic planning.',
    imageUrl:require ('../assets/emma2-removebg.png')
  },
  {
    name: 'Alice Johnson',
    role: 'Chief Operating Officer',
    bio: 'Alice oversees the daily operations and ensures the company runs smoothly.',
    imageUrl: require ('../assets/emma2-removebg.png')
  },
  {
    name: 'Alice Johnson',
    role: 'Chief Operating Officer',
    bio: 'Alice oversees the daily operations and ensures the company runs smoothly.',
    imageUrl: require ('../assets/emma2-removebg.png')
  },
  {
    name: 'Alice Johnson',
    role: 'Chief Operating Officer',
    bio: 'Alice oversees the daily operations and ensures the company runs smoothly.',
    imageUrl: require ('../assets/emma2-removebg.png')
  },
  {
    name: 'Alice Johnson',
    role: 'Chief Operating Officer',
    bio: 'Alice oversees the daily operations and ensures the company runs smoothly.',
    imageUrl: require ('../assets/emma2-removebg.png')
  },
  // Add more directors as needed
];

const DirectorCard = ({ name, role, bio, imageUrl, isCEO }) => {
    return (
      <div className={`max-w-sm rounded overflow-hidden shadow-lg bg-white m-4 ${isCEO ? 'w-full' : ''}`}>
        <img className="w-full" src={imageUrl} alt={name} />
        <div className="px-6 py-4">
          <div className="font-bold text-xl mb-2">{name}</div>
          <p className="text-gray-700 text-base">{role}</p>
          <p className="text-gray-600 text-sm mt-2">{bio}</p>
        </div>
      </div>
    );
  };
  
  const BoardPage = () => {
    // Separate the CEO and other directors
    const ceo = directors.find(director => director.role === 'Chief Executive Officer');
    const otherDirectors = directors.filter(director => director.role !== 'Chief Executive Officer');
  
    return (
      <div className="min-h-screen bg-gray-100 p-14">
        <header className="bg-[#023B8D] text-white p-6 rounded-lg shadow">
          <h1 className="text-3xl font-bold text-center">Management</h1>
        </header>
  
        <main className="mt-8">
          {/* CEO Section */}
          {ceo && (
            <div className="flex text-center justify-center">
              <DirectorCard
                name={ceo.name}
                role={ceo.role}
                bio={ceo.bio}
                imageUrl={ceo.imageUrl}
                isCEO={true}
              />
            </div>
          )}
  
          {/* Other Directors Section */}
          <div className="flex flex-wrap text-center justify-center mt-8">
            {otherDirectors.map((director, index) => (
              <DirectorCard
                key={index}
                name={director.name}
                role={director.role}
                bio={director.bio}
                imageUrl={director.imageUrl}
                isCEO={false}
              />
            ))}
          </div>
        </main>
      </div>
    );
  };
  
  export default BoardPage;